// extracted by css-extract-rspack-plugin
export default {"loaderContainer":"loaderContainer-P7M_Qc","loader":"loader-JOPVWr","show":"show-vOYTla"};